// This file is auto-generated by @hey-api/openapi-ts

import { type Options, getCalls, getCall, hangupCall, getCallRecording, getCallTelemetry, getCapacity, listReservations, reserveCapacity, getReservation, extendReservation, releaseReservation, startDemoCall, fleetAutoscaler, assembleCell, deleteCell, getFleetCell, addUnitToCell, fleetOverview, listFleetProviders, createFleetProvider, setProviderEtalon, confirmPauseSemantics, scanFleetProvider, scaleDown, scaleUp, listFleetSignals, clearFleetSignal, listFleetUnits, provisionUnit, getFleetUnit, deleteUnit, pauseUnit, resumeUnit, fleetWgPeers, listScenarios, createScenario, deleteScenario, getScenario, updateScenario, listSipAccounts, registerSipAccount, deleteSipAccount, getSipAccount, updateSipAccount, disableSipAccount, verifySipAccount, listLineLeases, releaseLineLease, listTelephonyPools, createTelephonyPool, getTelephonyPool, disableTelephonyPool, enableTelephonyPool, listTelephonyProfiles, createTelephonyProfile, retireTelephonyProfile, getTelephonyProfile, updateTelephonyProfile, startTestCall, unitClaim, unitConfig, unitHeartbeat, getUsage, listVoices, createVoice, deleteVoice, getVoice, getVoiceClip, getHealth, getReady } from '../sdk.gen';
import { queryOptions, type UseMutationOptions } from '@tanstack/react-query';
import type { GetCallsData, GetCallData, HangupCallData, HangupCallError, HangupCallResponse, GetCallRecordingData, GetCallTelemetryData, GetCapacityData, ListReservationsData, ReserveCapacityData, ReserveCapacityError, ReserveCapacityResponse, GetReservationData, ExtendReservationData, ExtendReservationError, ExtendReservationResponse, ReleaseReservationData, ReleaseReservationError, ReleaseReservationResponse, StartDemoCallData, StartDemoCallError, StartDemoCallResponse, FleetAutoscalerData, AssembleCellData, AssembleCellError, AssembleCellResponse, DeleteCellData, DeleteCellError, DeleteCellResponse, GetFleetCellData, AddUnitToCellData, AddUnitToCellError, AddUnitToCellResponse, FleetOverviewData, ListFleetProvidersData, CreateFleetProviderData, CreateFleetProviderError, CreateFleetProviderResponse, SetProviderEtalonData, SetProviderEtalonError, SetProviderEtalonResponse, ConfirmPauseSemanticsData, ConfirmPauseSemanticsError, ConfirmPauseSemanticsResponse, ScanFleetProviderData, ScaleDownData, ScaleDownError, ScaleDownResponse, ScaleUpData, ScaleUpError, ScaleUpResponse, ListFleetSignalsData, ClearFleetSignalData, ClearFleetSignalError, ClearFleetSignalResponse, ListFleetUnitsData, ProvisionUnitData, ProvisionUnitError, ProvisionUnitResponse, GetFleetUnitData, DeleteUnitData, DeleteUnitError, DeleteUnitResponse, PauseUnitData, PauseUnitError, PauseUnitResponse, ResumeUnitData, ResumeUnitError, ResumeUnitResponse, FleetWgPeersData, ListScenariosData, CreateScenarioData, CreateScenarioError, CreateScenarioResponse, DeleteScenarioData, DeleteScenarioError, DeleteScenarioResponse, GetScenarioData, UpdateScenarioData, UpdateScenarioError, UpdateScenarioResponse, ListSipAccountsData, RegisterSipAccountData, RegisterSipAccountError, RegisterSipAccountResponse, DeleteSipAccountData, DeleteSipAccountError, DeleteSipAccountResponse, GetSipAccountData, UpdateSipAccountData, UpdateSipAccountError, UpdateSipAccountResponse, DisableSipAccountData, DisableSipAccountError, DisableSipAccountResponse, VerifySipAccountData, VerifySipAccountError, VerifySipAccountResponse, ListLineLeasesData, ReleaseLineLeaseData, ReleaseLineLeaseError, ReleaseLineLeaseResponse, ListTelephonyPoolsData, CreateTelephonyPoolData, CreateTelephonyPoolError, CreateTelephonyPoolResponse, GetTelephonyPoolData, DisableTelephonyPoolData, DisableTelephonyPoolError, DisableTelephonyPoolResponse, EnableTelephonyPoolData, EnableTelephonyPoolError, EnableTelephonyPoolResponse, ListTelephonyProfilesData, CreateTelephonyProfileData, CreateTelephonyProfileError, CreateTelephonyProfileResponse, RetireTelephonyProfileData, RetireTelephonyProfileError, RetireTelephonyProfileResponse, GetTelephonyProfileData, UpdateTelephonyProfileData, UpdateTelephonyProfileError, UpdateTelephonyProfileResponse, StartTestCallData, StartTestCallError, StartTestCallResponse, UnitClaimData, UnitClaimError, UnitClaimResponse, UnitConfigData, UnitHeartbeatData, UnitHeartbeatError, UnitHeartbeatResponse, GetUsageData, ListVoicesData, CreateVoiceData, CreateVoiceError, CreateVoiceResponse, DeleteVoiceData, DeleteVoiceError, DeleteVoiceResponse, GetVoiceData, GetVoiceClipData, GetHealthData, GetReadyData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const getCallsQueryKey = (options?: Options<GetCallsData>) => createQueryKey('getCalls', options);

export const getCallsOptions = (options?: Options<GetCallsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCalls({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCallsQueryKey(options)
    });
};

export const getCallQueryKey = (options: Options<GetCallData>) => createQueryKey('getCall', options);

export const getCallOptions = (options: Options<GetCallData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCallQueryKey(options)
    });
};

export const hangupCallQueryKey = (options: Options<HangupCallData>) => createQueryKey('hangupCall', options);

export const hangupCallOptions = (options: Options<HangupCallData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await hangupCall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: hangupCallQueryKey(options)
    });
};

export const hangupCallMutation = (options?: Partial<Options<HangupCallData>>): UseMutationOptions<HangupCallResponse, HangupCallError, Options<HangupCallData>> => {
    const mutationOptions: UseMutationOptions<HangupCallResponse, HangupCallError, Options<HangupCallData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await hangupCall({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCallRecordingQueryKey = (options: Options<GetCallRecordingData>) => createQueryKey('getCallRecording', options);

export const getCallRecordingOptions = (options: Options<GetCallRecordingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCallRecording({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCallRecordingQueryKey(options)
    });
};

export const getCallTelemetryQueryKey = (options: Options<GetCallTelemetryData>) => createQueryKey('getCallTelemetry', options);

export const getCallTelemetryOptions = (options: Options<GetCallTelemetryData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCallTelemetry({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCallTelemetryQueryKey(options)
    });
};

export const getCapacityQueryKey = (options?: Options<GetCapacityData>) => createQueryKey('getCapacity', options);

export const getCapacityOptions = (options?: Options<GetCapacityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCapacity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCapacityQueryKey(options)
    });
};

export const listReservationsQueryKey = (options?: Options<ListReservationsData>) => createQueryKey('listReservations', options);

export const listReservationsOptions = (options?: Options<ListReservationsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listReservations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listReservationsQueryKey(options)
    });
};

export const reserveCapacityQueryKey = (options: Options<ReserveCapacityData>) => createQueryKey('reserveCapacity', options);

export const reserveCapacityOptions = (options: Options<ReserveCapacityData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await reserveCapacity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: reserveCapacityQueryKey(options)
    });
};

export const reserveCapacityMutation = (options?: Partial<Options<ReserveCapacityData>>): UseMutationOptions<ReserveCapacityResponse, ReserveCapacityError, Options<ReserveCapacityData>> => {
    const mutationOptions: UseMutationOptions<ReserveCapacityResponse, ReserveCapacityError, Options<ReserveCapacityData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await reserveCapacity({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getReservationQueryKey = (options: Options<GetReservationData>) => createQueryKey('getReservation', options);

export const getReservationOptions = (options: Options<GetReservationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReservation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReservationQueryKey(options)
    });
};

export const extendReservationMutation = (options?: Partial<Options<ExtendReservationData>>): UseMutationOptions<ExtendReservationResponse, ExtendReservationError, Options<ExtendReservationData>> => {
    const mutationOptions: UseMutationOptions<ExtendReservationResponse, ExtendReservationError, Options<ExtendReservationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await extendReservation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const releaseReservationQueryKey = (options: Options<ReleaseReservationData>) => createQueryKey('releaseReservation', options);

export const releaseReservationOptions = (options: Options<ReleaseReservationData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await releaseReservation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: releaseReservationQueryKey(options)
    });
};

export const releaseReservationMutation = (options?: Partial<Options<ReleaseReservationData>>): UseMutationOptions<ReleaseReservationResponse, ReleaseReservationError, Options<ReleaseReservationData>> => {
    const mutationOptions: UseMutationOptions<ReleaseReservationResponse, ReleaseReservationError, Options<ReleaseReservationData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await releaseReservation({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const startDemoCallQueryKey = (options: Options<StartDemoCallData>) => createQueryKey('startDemoCall', options);

export const startDemoCallOptions = (options: Options<StartDemoCallData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await startDemoCall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: startDemoCallQueryKey(options)
    });
};

export const startDemoCallMutation = (options?: Partial<Options<StartDemoCallData>>): UseMutationOptions<StartDemoCallResponse, StartDemoCallError, Options<StartDemoCallData>> => {
    const mutationOptions: UseMutationOptions<StartDemoCallResponse, StartDemoCallError, Options<StartDemoCallData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await startDemoCall({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fleetAutoscalerQueryKey = (options?: Options<FleetAutoscalerData>) => createQueryKey('fleetAutoscaler', options);

export const fleetAutoscalerOptions = (options?: Options<FleetAutoscalerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fleetAutoscaler({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: fleetAutoscalerQueryKey(options)
    });
};

export const assembleCellQueryKey = (options: Options<AssembleCellData>) => createQueryKey('assembleCell', options);

export const assembleCellOptions = (options: Options<AssembleCellData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await assembleCell({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: assembleCellQueryKey(options)
    });
};

export const assembleCellMutation = (options?: Partial<Options<AssembleCellData>>): UseMutationOptions<AssembleCellResponse, AssembleCellError, Options<AssembleCellData>> => {
    const mutationOptions: UseMutationOptions<AssembleCellResponse, AssembleCellError, Options<AssembleCellData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await assembleCell({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteCellMutation = (options?: Partial<Options<DeleteCellData>>): UseMutationOptions<DeleteCellResponse, DeleteCellError, Options<DeleteCellData>> => {
    const mutationOptions: UseMutationOptions<DeleteCellResponse, DeleteCellError, Options<DeleteCellData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteCell({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFleetCellQueryKey = (options: Options<GetFleetCellData>) => createQueryKey('getFleetCell', options);

export const getFleetCellOptions = (options: Options<GetFleetCellData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFleetCell({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFleetCellQueryKey(options)
    });
};

export const addUnitToCellQueryKey = (options: Options<AddUnitToCellData>) => createQueryKey('addUnitToCell', options);

export const addUnitToCellOptions = (options: Options<AddUnitToCellData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await addUnitToCell({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: addUnitToCellQueryKey(options)
    });
};

export const addUnitToCellMutation = (options?: Partial<Options<AddUnitToCellData>>): UseMutationOptions<AddUnitToCellResponse, AddUnitToCellError, Options<AddUnitToCellData>> => {
    const mutationOptions: UseMutationOptions<AddUnitToCellResponse, AddUnitToCellError, Options<AddUnitToCellData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await addUnitToCell({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fleetOverviewQueryKey = (options?: Options<FleetOverviewData>) => createQueryKey('fleetOverview', options);

export const fleetOverviewOptions = (options?: Options<FleetOverviewData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fleetOverview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: fleetOverviewQueryKey(options)
    });
};

export const listFleetProvidersQueryKey = (options?: Options<ListFleetProvidersData>) => createQueryKey('listFleetProviders', options);

export const listFleetProvidersOptions = (options?: Options<ListFleetProvidersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFleetProviders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFleetProvidersQueryKey(options)
    });
};

export const createFleetProviderQueryKey = (options: Options<CreateFleetProviderData>) => createQueryKey('createFleetProvider', options);

export const createFleetProviderOptions = (options: Options<CreateFleetProviderData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createFleetProvider({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createFleetProviderQueryKey(options)
    });
};

export const createFleetProviderMutation = (options?: Partial<Options<CreateFleetProviderData>>): UseMutationOptions<CreateFleetProviderResponse, CreateFleetProviderError, Options<CreateFleetProviderData>> => {
    const mutationOptions: UseMutationOptions<CreateFleetProviderResponse, CreateFleetProviderError, Options<CreateFleetProviderData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createFleetProvider({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setProviderEtalonQueryKey = (options: Options<SetProviderEtalonData>) => createQueryKey('setProviderEtalon', options);

export const setProviderEtalonOptions = (options: Options<SetProviderEtalonData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setProviderEtalon({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setProviderEtalonQueryKey(options)
    });
};

export const setProviderEtalonMutation = (options?: Partial<Options<SetProviderEtalonData>>): UseMutationOptions<SetProviderEtalonResponse, SetProviderEtalonError, Options<SetProviderEtalonData>> => {
    const mutationOptions: UseMutationOptions<SetProviderEtalonResponse, SetProviderEtalonError, Options<SetProviderEtalonData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await setProviderEtalon({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const confirmPauseSemanticsQueryKey = (options: Options<ConfirmPauseSemanticsData>) => createQueryKey('confirmPauseSemantics', options);

export const confirmPauseSemanticsOptions = (options: Options<ConfirmPauseSemanticsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await confirmPauseSemantics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: confirmPauseSemanticsQueryKey(options)
    });
};

export const confirmPauseSemanticsMutation = (options?: Partial<Options<ConfirmPauseSemanticsData>>): UseMutationOptions<ConfirmPauseSemanticsResponse, ConfirmPauseSemanticsError, Options<ConfirmPauseSemanticsData>> => {
    const mutationOptions: UseMutationOptions<ConfirmPauseSemanticsResponse, ConfirmPauseSemanticsError, Options<ConfirmPauseSemanticsData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await confirmPauseSemantics({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const scanFleetProviderQueryKey = (options: Options<ScanFleetProviderData>) => createQueryKey('scanFleetProvider', options);

export const scanFleetProviderOptions = (options: Options<ScanFleetProviderData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await scanFleetProvider({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: scanFleetProviderQueryKey(options)
    });
};

export const scaleDownQueryKey = (options: Options<ScaleDownData>) => createQueryKey('scaleDown', options);

export const scaleDownOptions = (options: Options<ScaleDownData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await scaleDown({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: scaleDownQueryKey(options)
    });
};

export const scaleDownMutation = (options?: Partial<Options<ScaleDownData>>): UseMutationOptions<ScaleDownResponse, ScaleDownError, Options<ScaleDownData>> => {
    const mutationOptions: UseMutationOptions<ScaleDownResponse, ScaleDownError, Options<ScaleDownData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await scaleDown({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const scaleUpQueryKey = (options: Options<ScaleUpData>) => createQueryKey('scaleUp', options);

export const scaleUpOptions = (options: Options<ScaleUpData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await scaleUp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: scaleUpQueryKey(options)
    });
};

export const scaleUpMutation = (options?: Partial<Options<ScaleUpData>>): UseMutationOptions<ScaleUpResponse, ScaleUpError, Options<ScaleUpData>> => {
    const mutationOptions: UseMutationOptions<ScaleUpResponse, ScaleUpError, Options<ScaleUpData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await scaleUp({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFleetSignalsQueryKey = (options?: Options<ListFleetSignalsData>) => createQueryKey('listFleetSignals', options);

export const listFleetSignalsOptions = (options?: Options<ListFleetSignalsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFleetSignals({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFleetSignalsQueryKey(options)
    });
};

export const clearFleetSignalQueryKey = (options: Options<ClearFleetSignalData>) => createQueryKey('clearFleetSignal', options);

export const clearFleetSignalOptions = (options: Options<ClearFleetSignalData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await clearFleetSignal({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: clearFleetSignalQueryKey(options)
    });
};

export const clearFleetSignalMutation = (options?: Partial<Options<ClearFleetSignalData>>): UseMutationOptions<ClearFleetSignalResponse, ClearFleetSignalError, Options<ClearFleetSignalData>> => {
    const mutationOptions: UseMutationOptions<ClearFleetSignalResponse, ClearFleetSignalError, Options<ClearFleetSignalData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await clearFleetSignal({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listFleetUnitsQueryKey = (options?: Options<ListFleetUnitsData>) => createQueryKey('listFleetUnits', options);

export const listFleetUnitsOptions = (options?: Options<ListFleetUnitsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listFleetUnits({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listFleetUnitsQueryKey(options)
    });
};

export const provisionUnitQueryKey = (options: Options<ProvisionUnitData>) => createQueryKey('provisionUnit', options);

export const provisionUnitOptions = (options: Options<ProvisionUnitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await provisionUnit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: provisionUnitQueryKey(options)
    });
};

export const provisionUnitMutation = (options?: Partial<Options<ProvisionUnitData>>): UseMutationOptions<ProvisionUnitResponse, ProvisionUnitError, Options<ProvisionUnitData>> => {
    const mutationOptions: UseMutationOptions<ProvisionUnitResponse, ProvisionUnitError, Options<ProvisionUnitData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await provisionUnit({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getFleetUnitQueryKey = (options: Options<GetFleetUnitData>) => createQueryKey('getFleetUnit', options);

export const getFleetUnitOptions = (options: Options<GetFleetUnitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFleetUnit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getFleetUnitQueryKey(options)
    });
};

export const deleteUnitQueryKey = (options: Options<DeleteUnitData>) => createQueryKey('deleteUnit', options);

export const deleteUnitOptions = (options: Options<DeleteUnitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await deleteUnit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: deleteUnitQueryKey(options)
    });
};

export const deleteUnitMutation = (options?: Partial<Options<DeleteUnitData>>): UseMutationOptions<DeleteUnitResponse, DeleteUnitError, Options<DeleteUnitData>> => {
    const mutationOptions: UseMutationOptions<DeleteUnitResponse, DeleteUnitError, Options<DeleteUnitData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteUnit({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const pauseUnitQueryKey = (options: Options<PauseUnitData>) => createQueryKey('pauseUnit', options);

export const pauseUnitOptions = (options: Options<PauseUnitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await pauseUnit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: pauseUnitQueryKey(options)
    });
};

export const pauseUnitMutation = (options?: Partial<Options<PauseUnitData>>): UseMutationOptions<PauseUnitResponse, PauseUnitError, Options<PauseUnitData>> => {
    const mutationOptions: UseMutationOptions<PauseUnitResponse, PauseUnitError, Options<PauseUnitData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await pauseUnit({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resumeUnitQueryKey = (options: Options<ResumeUnitData>) => createQueryKey('resumeUnit', options);

export const resumeUnitOptions = (options: Options<ResumeUnitData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resumeUnit({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resumeUnitQueryKey(options)
    });
};

export const resumeUnitMutation = (options?: Partial<Options<ResumeUnitData>>): UseMutationOptions<ResumeUnitResponse, ResumeUnitError, Options<ResumeUnitData>> => {
    const mutationOptions: UseMutationOptions<ResumeUnitResponse, ResumeUnitError, Options<ResumeUnitData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resumeUnit({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const fleetWgPeersQueryKey = (options?: Options<FleetWgPeersData>) => createQueryKey('fleetWgPeers', options);

export const fleetWgPeersOptions = (options?: Options<FleetWgPeersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fleetWgPeers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: fleetWgPeersQueryKey(options)
    });
};

export const listScenariosQueryKey = (options?: Options<ListScenariosData>) => createQueryKey('listScenarios', options);

export const listScenariosOptions = (options?: Options<ListScenariosData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listScenarios({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listScenariosQueryKey(options)
    });
};

export const createScenarioQueryKey = (options: Options<CreateScenarioData>) => createQueryKey('createScenario', options);

export const createScenarioOptions = (options: Options<CreateScenarioData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createScenario({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createScenarioQueryKey(options)
    });
};

export const createScenarioMutation = (options?: Partial<Options<CreateScenarioData>>): UseMutationOptions<CreateScenarioResponse, CreateScenarioError, Options<CreateScenarioData>> => {
    const mutationOptions: UseMutationOptions<CreateScenarioResponse, CreateScenarioError, Options<CreateScenarioData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createScenario({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteScenarioMutation = (options?: Partial<Options<DeleteScenarioData>>): UseMutationOptions<DeleteScenarioResponse, DeleteScenarioError, Options<DeleteScenarioData>> => {
    const mutationOptions: UseMutationOptions<DeleteScenarioResponse, DeleteScenarioError, Options<DeleteScenarioData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteScenario({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getScenarioQueryKey = (options: Options<GetScenarioData>) => createQueryKey('getScenario', options);

export const getScenarioOptions = (options: Options<GetScenarioData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getScenario({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getScenarioQueryKey(options)
    });
};

export const updateScenarioMutation = (options?: Partial<Options<UpdateScenarioData>>): UseMutationOptions<UpdateScenarioResponse, UpdateScenarioError, Options<UpdateScenarioData>> => {
    const mutationOptions: UseMutationOptions<UpdateScenarioResponse, UpdateScenarioError, Options<UpdateScenarioData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateScenario({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listSipAccountsQueryKey = (options?: Options<ListSipAccountsData>) => createQueryKey('listSipAccounts', options);

export const listSipAccountsOptions = (options?: Options<ListSipAccountsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSipAccounts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listSipAccountsQueryKey(options)
    });
};

export const registerSipAccountQueryKey = (options: Options<RegisterSipAccountData>) => createQueryKey('registerSipAccount', options);

export const registerSipAccountOptions = (options: Options<RegisterSipAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await registerSipAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: registerSipAccountQueryKey(options)
    });
};

export const registerSipAccountMutation = (options?: Partial<Options<RegisterSipAccountData>>): UseMutationOptions<RegisterSipAccountResponse, RegisterSipAccountError, Options<RegisterSipAccountData>> => {
    const mutationOptions: UseMutationOptions<RegisterSipAccountResponse, RegisterSipAccountError, Options<RegisterSipAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await registerSipAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteSipAccountMutation = (options?: Partial<Options<DeleteSipAccountData>>): UseMutationOptions<DeleteSipAccountResponse, DeleteSipAccountError, Options<DeleteSipAccountData>> => {
    const mutationOptions: UseMutationOptions<DeleteSipAccountResponse, DeleteSipAccountError, Options<DeleteSipAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteSipAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getSipAccountQueryKey = (options: Options<GetSipAccountData>) => createQueryKey('getSipAccount', options);

export const getSipAccountOptions = (options: Options<GetSipAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSipAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getSipAccountQueryKey(options)
    });
};

export const updateSipAccountMutation = (options?: Partial<Options<UpdateSipAccountData>>): UseMutationOptions<UpdateSipAccountResponse, UpdateSipAccountError, Options<UpdateSipAccountData>> => {
    const mutationOptions: UseMutationOptions<UpdateSipAccountResponse, UpdateSipAccountError, Options<UpdateSipAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateSipAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const disableSipAccountQueryKey = (options: Options<DisableSipAccountData>) => createQueryKey('disableSipAccount', options);

export const disableSipAccountOptions = (options: Options<DisableSipAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await disableSipAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: disableSipAccountQueryKey(options)
    });
};

export const disableSipAccountMutation = (options?: Partial<Options<DisableSipAccountData>>): UseMutationOptions<DisableSipAccountResponse, DisableSipAccountError, Options<DisableSipAccountData>> => {
    const mutationOptions: UseMutationOptions<DisableSipAccountResponse, DisableSipAccountError, Options<DisableSipAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await disableSipAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const verifySipAccountQueryKey = (options: Options<VerifySipAccountData>) => createQueryKey('verifySipAccount', options);

export const verifySipAccountOptions = (options: Options<VerifySipAccountData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await verifySipAccount({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: verifySipAccountQueryKey(options)
    });
};

export const verifySipAccountMutation = (options?: Partial<Options<VerifySipAccountData>>): UseMutationOptions<VerifySipAccountResponse, VerifySipAccountError, Options<VerifySipAccountData>> => {
    const mutationOptions: UseMutationOptions<VerifySipAccountResponse, VerifySipAccountError, Options<VerifySipAccountData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await verifySipAccount({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listLineLeasesQueryKey = (options?: Options<ListLineLeasesData>) => createQueryKey('listLineLeases', options);

export const listLineLeasesOptions = (options?: Options<ListLineLeasesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listLineLeases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listLineLeasesQueryKey(options)
    });
};

export const releaseLineLeaseQueryKey = (options: Options<ReleaseLineLeaseData>) => createQueryKey('releaseLineLease', options);

export const releaseLineLeaseOptions = (options: Options<ReleaseLineLeaseData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await releaseLineLease({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: releaseLineLeaseQueryKey(options)
    });
};

export const releaseLineLeaseMutation = (options?: Partial<Options<ReleaseLineLeaseData>>): UseMutationOptions<ReleaseLineLeaseResponse, ReleaseLineLeaseError, Options<ReleaseLineLeaseData>> => {
    const mutationOptions: UseMutationOptions<ReleaseLineLeaseResponse, ReleaseLineLeaseError, Options<ReleaseLineLeaseData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await releaseLineLease({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTelephonyPoolsQueryKey = (options?: Options<ListTelephonyPoolsData>) => createQueryKey('listTelephonyPools', options);

export const listTelephonyPoolsOptions = (options?: Options<ListTelephonyPoolsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listTelephonyPools({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTelephonyPoolsQueryKey(options)
    });
};

export const createTelephonyPoolQueryKey = (options: Options<CreateTelephonyPoolData>) => createQueryKey('createTelephonyPool', options);

export const createTelephonyPoolOptions = (options: Options<CreateTelephonyPoolData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createTelephonyPool({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createTelephonyPoolQueryKey(options)
    });
};

export const createTelephonyPoolMutation = (options?: Partial<Options<CreateTelephonyPoolData>>): UseMutationOptions<CreateTelephonyPoolResponse, CreateTelephonyPoolError, Options<CreateTelephonyPoolData>> => {
    const mutationOptions: UseMutationOptions<CreateTelephonyPoolResponse, CreateTelephonyPoolError, Options<CreateTelephonyPoolData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createTelephonyPool({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTelephonyPoolQueryKey = (options: Options<GetTelephonyPoolData>) => createQueryKey('getTelephonyPool', options);

export const getTelephonyPoolOptions = (options: Options<GetTelephonyPoolData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTelephonyPool({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTelephonyPoolQueryKey(options)
    });
};

export const disableTelephonyPoolQueryKey = (options: Options<DisableTelephonyPoolData>) => createQueryKey('disableTelephonyPool', options);

export const disableTelephonyPoolOptions = (options: Options<DisableTelephonyPoolData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await disableTelephonyPool({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: disableTelephonyPoolQueryKey(options)
    });
};

export const disableTelephonyPoolMutation = (options?: Partial<Options<DisableTelephonyPoolData>>): UseMutationOptions<DisableTelephonyPoolResponse, DisableTelephonyPoolError, Options<DisableTelephonyPoolData>> => {
    const mutationOptions: UseMutationOptions<DisableTelephonyPoolResponse, DisableTelephonyPoolError, Options<DisableTelephonyPoolData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await disableTelephonyPool({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const enableTelephonyPoolQueryKey = (options: Options<EnableTelephonyPoolData>) => createQueryKey('enableTelephonyPool', options);

export const enableTelephonyPoolOptions = (options: Options<EnableTelephonyPoolData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await enableTelephonyPool({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: enableTelephonyPoolQueryKey(options)
    });
};

export const enableTelephonyPoolMutation = (options?: Partial<Options<EnableTelephonyPoolData>>): UseMutationOptions<EnableTelephonyPoolResponse, EnableTelephonyPoolError, Options<EnableTelephonyPoolData>> => {
    const mutationOptions: UseMutationOptions<EnableTelephonyPoolResponse, EnableTelephonyPoolError, Options<EnableTelephonyPoolData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await enableTelephonyPool({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const listTelephonyProfilesQueryKey = (options?: Options<ListTelephonyProfilesData>) => createQueryKey('listTelephonyProfiles', options);

export const listTelephonyProfilesOptions = (options?: Options<ListTelephonyProfilesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listTelephonyProfiles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listTelephonyProfilesQueryKey(options)
    });
};

export const createTelephonyProfileQueryKey = (options: Options<CreateTelephonyProfileData>) => createQueryKey('createTelephonyProfile', options);

export const createTelephonyProfileOptions = (options: Options<CreateTelephonyProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createTelephonyProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createTelephonyProfileQueryKey(options)
    });
};

export const createTelephonyProfileMutation = (options?: Partial<Options<CreateTelephonyProfileData>>): UseMutationOptions<CreateTelephonyProfileResponse, CreateTelephonyProfileError, Options<CreateTelephonyProfileData>> => {
    const mutationOptions: UseMutationOptions<CreateTelephonyProfileResponse, CreateTelephonyProfileError, Options<CreateTelephonyProfileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createTelephonyProfile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const retireTelephonyProfileMutation = (options?: Partial<Options<RetireTelephonyProfileData>>): UseMutationOptions<RetireTelephonyProfileResponse, RetireTelephonyProfileError, Options<RetireTelephonyProfileData>> => {
    const mutationOptions: UseMutationOptions<RetireTelephonyProfileResponse, RetireTelephonyProfileError, Options<RetireTelephonyProfileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await retireTelephonyProfile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getTelephonyProfileQueryKey = (options: Options<GetTelephonyProfileData>) => createQueryKey('getTelephonyProfile', options);

export const getTelephonyProfileOptions = (options: Options<GetTelephonyProfileData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTelephonyProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getTelephonyProfileQueryKey(options)
    });
};

export const updateTelephonyProfileMutation = (options?: Partial<Options<UpdateTelephonyProfileData>>): UseMutationOptions<UpdateTelephonyProfileResponse, UpdateTelephonyProfileError, Options<UpdateTelephonyProfileData>> => {
    const mutationOptions: UseMutationOptions<UpdateTelephonyProfileResponse, UpdateTelephonyProfileError, Options<UpdateTelephonyProfileData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateTelephonyProfile({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const startTestCallQueryKey = (options: Options<StartTestCallData>) => createQueryKey('startTestCall', options);

export const startTestCallOptions = (options: Options<StartTestCallData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await startTestCall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: startTestCallQueryKey(options)
    });
};

export const startTestCallMutation = (options?: Partial<Options<StartTestCallData>>): UseMutationOptions<StartTestCallResponse, StartTestCallError, Options<StartTestCallData>> => {
    const mutationOptions: UseMutationOptions<StartTestCallResponse, StartTestCallError, Options<StartTestCallData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await startTestCall({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unitClaimQueryKey = (options: Options<UnitClaimData>) => createQueryKey('unitClaim', options);

export const unitClaimOptions = (options: Options<UnitClaimData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await unitClaim({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: unitClaimQueryKey(options)
    });
};

export const unitClaimMutation = (options?: Partial<Options<UnitClaimData>>): UseMutationOptions<UnitClaimResponse, UnitClaimError, Options<UnitClaimData>> => {
    const mutationOptions: UseMutationOptions<UnitClaimResponse, UnitClaimError, Options<UnitClaimData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await unitClaim({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const unitConfigQueryKey = (options: Options<UnitConfigData>) => createQueryKey('unitConfig', options);

export const unitConfigOptions = (options: Options<UnitConfigData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await unitConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: unitConfigQueryKey(options)
    });
};

export const unitHeartbeatQueryKey = (options: Options<UnitHeartbeatData>) => createQueryKey('unitHeartbeat', options);

export const unitHeartbeatOptions = (options: Options<UnitHeartbeatData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await unitHeartbeat({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: unitHeartbeatQueryKey(options)
    });
};

export const unitHeartbeatMutation = (options?: Partial<Options<UnitHeartbeatData>>): UseMutationOptions<UnitHeartbeatResponse, UnitHeartbeatError, Options<UnitHeartbeatData>> => {
    const mutationOptions: UseMutationOptions<UnitHeartbeatResponse, UnitHeartbeatError, Options<UnitHeartbeatData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await unitHeartbeat({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getUsageQueryKey = (options?: Options<GetUsageData>) => createQueryKey('getUsage', options);

export const getUsageOptions = (options?: Options<GetUsageData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUsage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getUsageQueryKey(options)
    });
};

export const listVoicesQueryKey = (options?: Options<ListVoicesData>) => createQueryKey('listVoices', options);

export const listVoicesOptions = (options?: Options<ListVoicesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listVoices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: listVoicesQueryKey(options)
    });
};

export const createVoiceQueryKey = (options: Options<CreateVoiceData>) => createQueryKey('createVoice', options);

export const createVoiceOptions = (options: Options<CreateVoiceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createVoice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createVoiceQueryKey(options)
    });
};

export const createVoiceMutation = (options?: Partial<Options<CreateVoiceData>>): UseMutationOptions<CreateVoiceResponse, CreateVoiceError, Options<CreateVoiceData>> => {
    const mutationOptions: UseMutationOptions<CreateVoiceResponse, CreateVoiceError, Options<CreateVoiceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createVoice({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteVoiceMutation = (options?: Partial<Options<DeleteVoiceData>>): UseMutationOptions<DeleteVoiceResponse, DeleteVoiceError, Options<DeleteVoiceData>> => {
    const mutationOptions: UseMutationOptions<DeleteVoiceResponse, DeleteVoiceError, Options<DeleteVoiceData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteVoice({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getVoiceQueryKey = (options: Options<GetVoiceData>) => createQueryKey('getVoice', options);

export const getVoiceOptions = (options: Options<GetVoiceData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVoice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getVoiceQueryKey(options)
    });
};

export const getVoiceClipQueryKey = (options: Options<GetVoiceClipData>) => createQueryKey('getVoiceClip', options);

export const getVoiceClipOptions = (options: Options<GetVoiceClipData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVoiceClip({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getVoiceClipQueryKey(options)
    });
};

export const getHealthQueryKey = (options?: Options<GetHealthData>) => createQueryKey('getHealth', options);

export const getHealthOptions = (options?: Options<GetHealthData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getHealth({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHealthQueryKey(options)
    });
};

export const getReadyQueryKey = (options?: Options<GetReadyData>) => createQueryKey('getReady', options);

export const getReadyOptions = (options?: Options<GetReadyData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReady({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getReadyQueryKey(options)
    });
};